import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { AuthProvider } from 'hooks/useAuth';
import ProtectedRoute from 'components/ProtectedRoute';
import AdminLayout from 'components/Layout';
import Login from 'pages/Login';
import Dashboard from 'pages/Dashboard';
import Users from 'pages/Users';
import UserDetail from 'pages/UserDetail';
import Revenue from 'pages/Revenue';
import Content from 'pages/Content';
import Email from 'pages/Email';

const theme = {
  token: {
    colorPrimary: '#1a7a4f',
    borderRadius: 6,
  },
};

const App: React.FC = () => {
  return (
    <ConfigProvider theme={theme}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/*" element={
              <ProtectedRoute>
                <AdminLayout>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/users" element={<Users />} />
                    <Route path="/users/:id" element={<UserDetail />} />
                    <Route path="/revenue" element={<Revenue />} />
                    <Route path="/content" element={<Content />} />
                    <Route path="/email" element={<Email />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </AdminLayout>
              </ProtectedRoute>
            } />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ConfigProvider>
  );
};

export default App;
